import { Col, Row, Table } from "antd";
import { find, get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MdContentCopy,
  MdOpenInNew,
  MdOutlineDeleteOutline,
  MdVpnKey,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS, USER_TYPES } from "utils/constants";
import ApiCredentialModal from "../ApiCredential/View";
import DuplicateModal from "../Duplicate";

function List({ data, count, setValues, skip, canDuplicate }) {
  const navigate = useNavigate();
  const [credentialTarget, setCredentialTarget] = useState(null);
  const [duplicateTarget, setDuplicateTarget] = useState(null);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const LIST = t("LIST", { returnObjects: true });
  const COMPANY_TYPE = t("COMPANY_TYPE", {
    returnObjects: true,
  });

  const columns = [
    // {
    //   title: LIST.LOGO,
    //   dataIndex: "type",
    //   render: (item) =>
    //     <img src="/favicon.ico" alt={LIST.LOGO} className="logo--table" /> || (
    //       <img src="/favicon.ico" alt={LIST.LOGO} className="logo--table" />
    //     ),
    // },
    {
      title: LIST.BUSINESS_NAME,
      dataIndex: "organization",
      render: (item) => get(item, "name", "-"),
      key: "name",
      fixed: true,
    },
    // {
    //   title: LIST.TYPE,
    //   dataIndex: "organization",
    //   render: (item) => PROFILE_TYPES[get(item, "type", "-")],
    //   key: "type",
    //   fixed: true,
    // },
    {
      title: LIST.SOCIAL_REASON,
      dataIndex: "socialReason",
      render: (record) => record || "-",
    },
    {
      title: LIST.CATEGORY,
      dataIndex: "organization",
      render: (item) =>
        COMPANY_TYPE[get(item, "type")] || get(item, "type") || "-",
      key: "category",
    },
    {
      title: LIST.LEGAL,
      dataIndex: "organization",
      render: (item) => {
        const user = find(
          get(item, "users", []),
          (user) =>
            get(user, "meta.type") === USER_TYPES.BROKER_ADMIN.type ||
            get(user, "meta.type") === USER_TYPES.INTERNAL_SUPERVISOR.type,
        );
        if (!user) return "-";
        return `${get(LIST, `GENDER.${user.gender}`, "")} ${user.firstname} ${
          user.lastname
        }`;
      },
      key: "legal",
    },
    {
      title: LIST.PHONE,
      dataIndex: "organization",
      render: (item) =>
        find(
          get(item, "users", []),
          (user) =>
            get(user, "meta.type") === USER_TYPES.BROKER_ADMIN.type ||
            get(user, "meta.type") === USER_TYPES.INTERNAL_SUPERVISOR.type,
        )?.phone || "-",
      key: "phone",
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id, record) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            title={LIST.ACTIONS}
            onClick={() => setCredentialTarget(get(record, "organization"))}
          >
            <MdVpnKey size={24} color={COLORS.C_PRIMARY} />
          </Col>
          {canDuplicate && (
            <Col
              title={LIST.DUPLICATE}
              onClick={() => setDuplicateTarget(get(record, "organization"))}
            >
              <MdContentCopy size={24} color={COLORS.C_PRIMARY} />
            </Col>
          )}
          <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.BROKERS.DETAIL.path}/${id}`)
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          {/* <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.BROKERS.DELETE.path}/${id}`)
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col> */}
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
      <ApiCredentialModal
        open={Boolean(credentialTarget)}
        organization={credentialTarget}
        onClose={() => setCredentialTarget(null)}
      />
      {canDuplicate && (
        <DuplicateModal
          open={Boolean(duplicateTarget)}
          organization={duplicateTarget}
          onClose={() => setDuplicateTarget(null)}
        />
      )}
    </>
  );
}

export default List;
